import { features } from './features'; 

features.applicationType = 'agrogest';
features.hasClients = false;
features.userCanSeeAllRecords  = true;

features.showVisitas = false;
features.showAnalisis = true;
features.showTareasOtros = true;
features.showTareasOtrosDuracion = true;
features.showTareasFitoHoras = true;
features.showRegistroTratamiento = true;
features.showTractorBoquillas = false;
features.showTractorMarcha = false;
features.showTractorPresion = false;
features.showTractorRPM = false;
features.showTractorVelocidad = false;
features.showTractorKmRecorridos = false;
features.precioHora = true;
features.showTrabajadoresCargos = true;
features.showEnviarCorreo = true;
features.showEnviarWhatsapp = true;
features.showStock = true;
features.showStockProveedor = true;
features.showStockSemilla = true;
features.showStockProveedorClienteDropdown = true;
features.showStockTipoDeDato = true;
features.showAnalisisSectorParcelas = true;
features.showTareasGenericasObservaciones = true;
features.showTareasFertiObservaciones = true;
features.userCanSeeCostes = true;
features.showCostes = true;
features.showCostesOtros = true;
features.showTareasFitoSectorMultiple = true;
features.showRecetaPascualCabedo = true;
features.showTratamientosAllProductos = true;
features.showMapaTratamientos = true;
features.showMapaLabels = true;
features.showVentusky = true;
features.showTareasFitoLitrosAplicados = true;
features.activateSIEX = true;
features.showDocumentUploadVisitas = false;
features.showAplicadoSwitch = true;
features.showAssignUserInAllTasks = false;
features.showTareasAplicados = true;
features.showTrabajadoresFertilizantes = true;
features.showTareasPrioridad = true;
features.showVentasComercioProveedor = true;
features.showTareasBio = false;
features.showCalendarioTareas = false;
features.showTareasOtrasProducto = true;
features.showTareasFitoBetweenDates = true;

export const environment = {
    production: true,
    v: '2',
    serverUrl: 'https://herbesdelmoli.agrogest.com/',
    logoUrl: 'assets/logo_herbesdelmoli.png',
    appName: 'herbesdelmoli',
    features: features
};
